import { Component, Input } from '@angular/core';
import { SalvageTabContext } from '../salvage-tab-context';

@Component({
  selector: 'app-salvage-expired-invoices-tab',
  templateUrl: './salvage-expired-invoices-tab.component.html',
})
export class SalvageExpiredInvoicesTabComponent {
  @Input() context!: SalvageTabContext;
}
